var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Log_Out",
    "data-name": "Icon - Log Out",
    transform: "translate(16 16) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    "data-name": "Vector 3",
    d: "M2.571,14.4a.889.889,0,0,1-.606-.234.774.774,0,0,1-.251-.566V2.4a.774.774,0,0,1,.251-.566A.889.889,0,0,1,2.571,1.6H6A.83.83,0,0,0,6.857.8.83.83,0,0,0,6,0H2.571A2.668,2.668,0,0,0,.753.7,2.322,2.322,0,0,0,0,2.4V13.6a2.322,2.322,0,0,0,.753,1.7,2.668,2.668,0,0,0,1.818.7H6a.8.8,0,1,0,0-1.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    "data-name": "Vector 2",
    d: "M.239,8.92a.858.858,0,0,0,1.154,0L5.475,5.11a.727.727,0,0,0,0-1.077L1.394.223a.858.858,0,0,0-1.154,0,.727.727,0,0,0,0,1.077l3.5,3.271L.239,7.842A.727.727,0,0,0,.239,8.92Z",
    transform: "translate(10.286 3.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_1",
    "data-name": "Vector 1",
    d: "M0,1.143c0,.631.365,1.143.816,1.143h9.8c.451,0,.816-.512.816-1.143S11.063,0,10.612,0H.816C.365,0,0,.512,0,1.143Z",
    transform: "translate(4.571 6.857)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.fa82ac23c39b1224a6aac28f48965d59.svg";
export { ForwardRef as ReactComponent };